import { USER_BACKEND_URL } from '../config/config';
import api from './api';

export interface Prompt {
  _id?: string;
  text?: string;
  prompt?: string;
  title?: string;
  braintrust_slug?: string;
  response?: string;
  createdAt: Date;
}

export interface PromptListResponse {
  success: boolean;
  count: number;
  data: Prompt[];
}

export interface PromptResponse {
  success: boolean;
  data: Prompt;
}

class PromptService {
  /**
   * Get all prompts for a company
   */
  async getCompanyPrompts(payload: any): Promise<PromptListResponse> {
    try {
      const response = await api.post(`${USER_BACKEND_URL}prompt/promptList`, payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching prompts:', error);
      throw error;
    }
  }

  async getJobSeekerPrompts(): Promise<PromptListResponse> {
    try {
      const response = await api.post(`${USER_BACKEND_URL}prompt/jobSeekerPromptList`);
      return response.data;
    } catch (error) {
      console.error('Error fetching job seeker prompts:', error);
      throw error;
    }
  }

  async updatePromptsJobSeeker(): Promise<any> {
    try {
      const response = await api.post(`${USER_BACKEND_URL}prompt/updatePromptsJobSeeker`);
      return response.data;
    } catch (error) {
      console.error('Error updating job seeker prompts:', error);
      throw error;
    }
  }

  async getDefaultPromptList() {
    try {
      const response = await api.post(`${USER_BACKEND_URL}prompt/getDefaultPrompt`);
      return response.data;
    } catch (error) {
      console.error('Error fetching default prompts:', error);
      throw error;
    }
  }

  async getResetPrompt(id: any) {
    try {
      const response = await api.delete(`${USER_BACKEND_URL}prompt/deletePrompt/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching project rounds:', error);
      throw error;
    }
  }

  /**
   * Add a new prompt
   */
  async addPrompt(payload: any): Promise<Prompt> {
    try {
      const response = await api.post(`${USER_BACKEND_URL}prompt/addPrompt`, payload);
      return response.data.data;
    } catch (error) {
      console.error('Error adding prompt:', error);
      throw error;
    }
  }

  async editPrompt(payload: any): Promise<Prompt> {
    try {
      const response = await api.post(`${USER_BACKEND_URL}prompt/editPrompt`, payload);
      return response.data.data;
    } catch (error) {
      console.error('Error editing prompt:', error);
      throw error;
    }
  }

  async updatePrompts(): Promise<any> {
    try {
      const response = await api.post(`${USER_BACKEND_URL}prompt/updatePrompts`);
      return response.data;
    } catch (error) {
      console.error('Error updating prompts:', error);
      throw error;
    }
  }

  /**
   * Delete a prompt
   */
  async deletePrompt(companyId: string, promptId: string): Promise<void> {
    try {
      await api.delete(`/companies/${companyId}/prompts/${promptId}`);
    } catch (error) {
      console.error('Error deleting prompt:', error);
      throw error;
    }
  }
}

export default new PromptService();